import { ReportingControllerBaseConfig } from '../../../base';
import { DocumentFormController } from './documentFormInterface';
import { DocumentFormViewProps, DocumentFormControllerProps } from './documentFormProps';
import { DocumentFormAggregate, DocumentFormTab } from './documentFormModel';
import { AiOutlineHistory, AiOutlineTable } from 'react-icons/ai';
import { BiCommentDetail } from 'react-icons/bi';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { assert } from '@varos/util-typescript';
import { IconType } from 'react-icons';

export function createDocumentFormController(
    config: ReportingControllerBaseConfig
): DocumentFormController {
    const {
        kernel: {
            infra: { formatter },
            provider: { createFormController },
        },
    } = config;

    const tabs = [
        {
            id: 'interview',
            label: 'Interview',
            Icon: HiOutlineDocumentText,
        },
        {
            id: 'responses',
            label: 'Responses',
            Icon: AiOutlineTable,
        },
    ] satisfies Array<{
        id: DocumentFormTab;
        label: string;
        Icon: IconType;
    }>;

    return {
        useProps(context, item, props): DocumentFormViewProps {
            return {
                document: {
                    label: item.document.title ?? 'Untitled',
                    icon: item.document.icon
                        ? {
                              kind: 'emoji',
                              text: item.document.icon,
                          }
                        : {
                              kind: 'icon',
                              Component: HiOutlineDocumentText,
                          },
                },
                builder: {
                    document: item.document,
                    form: item.form,
                },
                collection: {
                    collection: item.form.collection,
                },
                tab: {
                    root: {
                        index: tabs.findIndex((tab) => tab.id === props.tab.value),
                        onChange(index) {
                            const found = tabs[index];
                            assert(found, 'Tab not found');
                            props.tab.onChange(found.id);
                        },
                    },
                    items: tabs,
                },
                actions: [
                    {
                        id: 'history',
                        Icon: AiOutlineHistory,
                        tooltip: {
                            label: 'Show history',
                        },
                        button: {
                            onClick() {
                                console.log('show history');
                            },
                        },
                    },
                    {
                        id: 'comments',
                        Icon: BiCommentDetail,
                        tooltip: {
                            label: 'Show all comments',
                        },
                        button: {
                            onClick() {
                                console.log('show all comments');
                            },
                        },
                    },
                ],
            };
        },
    };
}
